import type { ReactNode } from 'react'
import s from './Urgent.module.css'

/** L'étiquette « URGENT » : la case du bureau, cochée (BACK-OFFICE-X). */
export function UrgentTag() {
  return <span className={s.tag}>Urgent</span>
}

/**
 * Pose l'étiquette **au-dessus** de son contenu quand `urgent` est vrai, et rend le contenu seul
 * sinon. `urgent` accepte `undefined` : une donnée d'avant la case ne vaut pas « urgent ».
 */
export function UrgentStack({
  urgent,
  children,
}: {
  urgent: boolean | undefined
  children: ReactNode
}) {
  if (urgent !== true) return <>{children}</>
  return (
    <span className={s.stack}>
      <UrgentTag />
      {children}
    </span>
  )
}

/**
 * La classe d'une **carte** urgente (cadre rouge, fond pâle). Une rangée de tableau, elle, pose
 * `data-urgent` sur son `<tr>` : `DataTable` la peint.
 */
export const urgentSurface = s.surface
